import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ConcursoInscricoesAbertas {
  id: number;
  processo: string;
  titulo: string;
  campus: string;
  siglaUnidade: string;
  inicio: string;
  fim: string;
  diasRestantes: number;
  encerrando7Dias: boolean;
  quantidadeInscritos: number;
}

export interface ConcursoComissaoIncompleta {
  id: number;
  processo: string;
}

export interface RecursoPorConcurso {
  processo: string;
  parecer: string;
  quantidade: number;
}

export interface MembroComissao {
  username: string;
  nome: string;
  matricula: string;
  quantidadeConcursos: number;
}

export interface InscricaoGeneroCategoria {
  categoria: string;
  sexo: string;
  quantidade: number;
}

export interface DashboardData {
  concursosPorAndamento: { [key: string]: number };
  concursosInscricoesAbertas: ConcursoInscricoesAbertas[];
  concursosEncerradosPorUnidade: { [key: string]: number };
  inscricoesPorStatus: { [key: string]: number };
  totalInscricoesPeriodo: number | null;
  concursosPorUnidade: { [key: string]: number };
  inscricoesPorUnidade: { [key: string]: number };
  concursosPorTipo: { [key: string]: number };
  deferimentosPorTipo: { [key: string]: number };
  indeferimentosPorTipo: { [key: string]: number };
  concursosPorFase: { [key: string]: number };
  inscricoesNaoConfirmadasPorConcurso: { [key: string]: number };
  concursosComissaoIncompleta: ConcursoComissaoIncompleta[];
  recursosPorConcurso: RecursoPorConcurso[];
  concursosPorMembro: MembroComissao[];
  provasPorFase: { [key: string]: number };
  inscricoesPorGeneroPorUnidade: InscricaoGeneroCategoria[];
  inscricoesPorGeneroPorTipo: InscricaoGeneroCategoria[];
  inscricoesPorStatusHeteroidentificacao: { [key: string]: number };
  provasPorTipoEFase: InscricaoGeneroCategoria[];
  ausenciasPorTipoProva: { [key: string]: number };
  fase1Aprovados: number | null;
  fase1Reprovados: number | null;
  fase2Aprovados: number | null;
  fase2Reprovados: number | null;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly baseUrl = `${environment.baseUrlApi}/dashboard`;

  constructor(private http: HttpClient) {}

  getDashboard(filtro: { mes?: number; ano?: number; dataInicio?: string; dataFim?: string; tab?: string }): Observable<DashboardData> {
    let params = new HttpParams();
    if (filtro.dataInicio) params = params.set('dataInicio', filtro.dataInicio);
    if (filtro.dataFim) params = params.set('dataFim', filtro.dataFim);
    if (!filtro.dataInicio && filtro.mes) params = params.set('mes', filtro.mes.toString());
    if (!filtro.dataInicio && filtro.ano) params = params.set('ano', filtro.ano.toString());
    if (filtro.tab) params = params.set('tab', filtro.tab);
    return this.http.get<DashboardData>(this.baseUrl, { params });
  }
}
